/* ═══════════════════════════════════════════════
   BRICKBLAST THEME — theme.js
   Shopify AJAX Cart, Payments, UI interactions
   ═══════════════════════════════════════════════ */
(function() {
  'use strict';

  /* ── FREE SHIPPING THRESHOLD (from settings) ── 0 = always free */
  var FREE_SHIP_CENTS = 5900;
  if (window.ShopifyConfig && typeof window.ShopifyConfig.freeShippingThreshold !== 'undefined') {
    FREE_SHIP_CENTS = parseInt(window.ShopifyConfig.freeShippingThreshold, 10) * 100;
  }

  /* ── UTILITY: format money ── */
  function formatMoney(cents) {
    var fmt = (window.ShopifyConfig && window.ShopifyConfig.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.floor(cents/100)).replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  /* ── TOAST ── */
  var toastTimer;
  function showToast(msg) {
    var t = document.getElementById('toast');
    var txt = document.getElementById('toastTxt');
    if (!t || !txt) return;
    txt.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() { t.classList.remove('on'); }, 2800);
  }

  /* ══════════════════════════════════════
     SHOPIFY AJAX CART
  ══════════════════════════════════════ */

  /* Fetch current cart state from Shopify */
  function fetchCart(cb) {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { cb && cb(cart); })
      .catch(function(e) { console.error('Cart fetch error:', e); });
  }

  /* Add item to Shopify cart */
  function cartAdd(variantId, qty, properties, cb) {
    var body = { id: parseInt(variantId), quantity: qty || 1 };
    if (properties) body.properties = properties;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || 'Could not add item'); });
      return r.json();
    })
    .then(function(item) { cb && cb(null, item); })
    .catch(function(err) { cb && cb(err); });
  }

  /* Update item quantity */
  function cartChange(key, qty, cb) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { cb && cb(null, cart); })
    .catch(function(err) { cb && cb(err); });
  }

  /* Remove item */
  function cartRemove(key, cb) { cartChange(key, 0, cb); }

  /* Update the cart drawer UI */
  function updateCartUI(cart) {
    var count = cart.item_count;
    var total = cart.total_price;

    /* Badge */
    var badge = document.getElementById('cartBadge');
    if (badge) {
      badge.textContent = count;
      badge.classList.toggle('on', count > 0);
      if (__lastCartCount !== null && count > __lastCartCount) bumpCartBadge();
    }
    __lastCartCount = count;

    /* Drawer count */
    var drawerCount = document.getElementById('drawerCount');
    if (drawerCount) drawerCount.textContent = '(' + count + ')';

    /* Footer visibility */
    var foot = document.getElementById('cartFoot');
    var empty = document.getElementById('cartEmpty');
    if (foot) foot.style.display = count > 0 ? 'block' : 'none';
    if (empty) empty.style.display = count > 0 ? 'none' : 'flex';

    /* Total */
    var totalEl = document.getElementById('cartTotal');
    if (totalEl) totalEl.textContent = formatMoney(total);

    /* Shipping progress bar */
    var spText  = document.getElementById('spText');
    var spFill  = document.getElementById('spFill');
    if (spText && spFill && FREE_SHIP_CENTS > 0) {
      var pct = Math.min(100, Math.round(total / FREE_SHIP_CENTS * 100));
      spFill.style.width = pct + '%';
      if (total >= FREE_SHIP_CENTS) {
        spText.textContent = '🎉 You\'ve unlocked free shipping!';
        spText.classList.add('done');
      } else {
        var remaining = formatMoney(FREE_SHIP_CENTS - total);
        spText.textContent = 'Add ' + remaining + ' more for free shipping';
        spText.classList.remove('done');
      }
    }

    /* Bundle deal progress bar — Buy X Get Y Free */
    var bundleBar = document.getElementById('bundleBar');
    if (bundleBar) {
      var qualifyQty = parseInt(bundleBar.getAttribute('data-qualify-qty'), 10) || 3;
      var freeQty    = parseInt(bundleBar.getAttribute('data-free-qty'), 10)    || 1;
      var totalNeeded = qualifyQty + freeQty;
      var bbText = document.getElementById('bbText');
      var bbFill = document.getElementById('bbFill');
      if (bbText && bbFill) {
        var pct = Math.min(100, Math.round((count / totalNeeded) * 100));
        bbFill.style.width = pct + '%';
        if (count >= totalNeeded) {
          bbText.innerHTML = '🎉 Bundle unlocked! Your <strong>free item</strong> applies at checkout.';
          bundleBar.classList.add('done');
        } else if (count >= qualifyQty) {
          var stillNeeded = totalNeeded - count;
          bbText.innerHTML = '🎁 Add <strong>' + stillNeeded + '</strong> more ' + (stillNeeded === 1 ? 'item' : 'items') + ' — and it\'s <strong>FREE</strong>!';
          bundleBar.classList.remove('done');
        } else {
          var needed = qualifyQty - count;
          bbText.innerHTML = '🎁 Add <strong>' + needed + '</strong> more ' + (needed === 1 ? 'item' : 'items') + ' to unlock your <strong>FREE</strong> bonus!';
          bundleBar.classList.remove('done');
        }
      }
    }

    /* Rebuild cart items */
    var body = document.getElementById('cartBody');
    if (!body) return;
    var wrap = document.getElementById('cartItemsWrap');
    if (wrap) wrap.remove();

    if (count > 0) {
      var itemsWrap = document.createElement('div');
      itemsWrap.id = 'cartItemsWrap';
      cart.items.forEach(function(item) {
        var div = document.createElement('div');
        div.className = 'cart-item';
        div.dataset.key = item.key;
        var imgHtml = item.featured_image && item.featured_image.url
          ? '<img src="' + item.featured_image.url + '" alt="' + (item.featured_image.alt || item.product_title) + '" width="66" height="66" loading="lazy">'
          : '<span>' + item.product_title.charAt(0) + '</span>';
        var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="ci-variant">' + item.variant_title + '</div>'
          : '';
        var attr = function(v) { return String(v == null ? '' : v).replace(/"/g, '&quot;'); };
        var saveImg = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
        div.innerHTML =
          '<div class="ci-img"><a href="' + item.url + '">' + imgHtml + '</a></div>' +
          '<div class="ci-details">' +
            '<div class="ci-name">' + item.product_title + '</div>' +
            variantHtml +
            '<div class="qty-ctrl">' +
              '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease">−</button>' +
              '<span class="qty-n">' + item.quantity + '</span>' +
              '<button class="qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<div class="ci-actions">' +
              '<button class="ci-save-later"' +
                ' data-key="' + attr(item.key) + '"' +
                ' data-variant-id="' + attr(item.variant_id) + '"' +
                ' data-product-title="' + attr(item.product_title) + '"' +
                ' data-variant-title="' + attr(item.variant_title) + '"' +
                ' data-price="' + attr(formatMoney(item.price)) + '"' +
                ' data-image="' + attr(saveImg) + '"' +
                ' data-url="' + attr(item.url) + '">Save for Later</button>' +
              '<button class="ci-remove" data-key="' + attr(item.key) + '">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="ci-price">' + formatMoney(item.final_line_price) + '</div>';
        itemsWrap.appendChild(div);
      });
      body.insertBefore(itemsWrap, body.firstChild);
      addCartItemListeners(itemsWrap);
    }
  }

  function addCartItemListeners(wrap) {
    wrap.querySelectorAll('.qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.key;
        var action = btn.dataset.action;
        var qtyEl = btn.parentElement.querySelector('.qty-n');
        var current = parseInt(qtyEl ? qtyEl.textContent : 1);
        var newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
        cartChange(key, newQty, function(err, cart) {
          if (err) return showToast('Error updating cart');
          updateCartUI(cart);
        });
      });
    });
    wrap.querySelectorAll('.ci-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        cartRemove(btn.dataset.key, function(err, cart) {
          if (err) return showToast('Error removing item');
          updateCartUI(cart);
          showToast('Item removed');
        });
      });
    });
  }

  /* ── Fly-to-cart animation ──────────────────────────────────
     Clones the source image, animates it to the cart icon in the
     header, then removes the clone. Skipped when user prefers
     reduced motion. */
  function flyToCart(sourceImg) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!sourceImg) return;
    var cartIcon = document.getElementById('cartBadge') || document.querySelector('a[href*="/cart"] svg, .icon-btn[href*="/cart"]');
    if (!cartIcon) return;
    var src = sourceImg.getBoundingClientRect();
    var dest = cartIcon.getBoundingClientRect();
    if (!src.width || !src.height) return;
    /* Build a brand-new img element instead of cloneNode — that way no class,
       id, or other attribute from the source can be matched by site CSS and
       override the inline animation styles below. */
    var clone = new Image();
    clone.src = sourceImg.currentSrc || sourceImg.src;
    clone.alt = '';
    clone.style.cssText =
      'position:fixed !important;top:' + src.top + 'px !important;left:' + src.left + 'px !important;' +
      'width:' + src.width + 'px !important;height:' + src.height + 'px !important;' +
      'z-index:99998 !important;pointer-events:none !important;border-radius:12px;' +
      'box-shadow:0 12px 40px rgba(0,0,0,0.3);object-fit:cover !important;' +
      'transition:all 0.85s cubic-bezier(0.6,-0.28,0.74,0.05) !important;' +
      'transform-origin:center;will-change:transform,top,left,width,height,opacity;' +
      'visibility:visible !important;opacity:1 !important;display:block !important;margin:0 !important;padding:0 !important;';
    document.body.appendChild(clone);
    void clone.offsetWidth;
    var destX = dest.left + dest.width / 2 - 16;
    var destY = dest.top + dest.height / 2 - 16;
    /* Clamp destination to viewport. The cart badge can be scrolled off the
       top of the screen on long product pages; without clamping, the image
       would fly upward into the void and the user would see nothing. */
    if (destY < 20) destY = 20;
    if (destY > window.innerHeight - 50) destY = window.innerHeight - 50;
    if (destX < 20) destX = window.innerWidth - 50;
    if (destX > window.innerWidth - 20) destX = window.innerWidth - 50;
    clone.style.top = destY + 'px';
    clone.style.left = destX + 'px';
    clone.style.width = '32px';
    clone.style.height = '32px';
    clone.style.opacity = '0.2';
    clone.style.transform = 'rotate(180deg) scale(0.2)';
    setTimeout(function() { clone.parentNode && clone.parentNode.removeChild(clone); }, 900);
  }

  /* Bump the cart badge when count rises */
  var __lastCartCount = null;
  function bumpCartBadge() {
    var badge = document.getElementById('cartBadge');
    if (!badge) return;
    badge.classList.remove('bump');
    void badge.offsetWidth;
    badge.classList.add('bump');
  }

  /* Open / close cart drawer */
  function openCart() {
    document.getElementById('cartDrawer') && document.getElementById('cartDrawer').classList.add('on');
    document.getElementById('overlay') && document.getElementById('overlay').classList.add('on');
    document.body.style.overflow = 'hidden';
    /* Refresh cart data */
    fetchCart(updateCartUI);
  }

  function closeCart() {
    document.getElementById('cartDrawer') && document.getElementById('cartDrawer').classList.remove('on');
    document.getElementById('overlay') && document.getElementById('overlay').classList.remove('on');
    document.body.style.overflow = '';
  }

  /* Quick add (product cards) */
  function quickAdd(btn) {
    var variantId = btn.dataset.variantId;
    var title = btn.dataset.productTitle || 'Item';
    if (!variantId) return;
    /* Fly-to-cart: pick the card's primary image */
    var card = btn.closest('.p-card');
    var sourceImg = card && card.querySelector('.p-img img.img-primary, .p-img img');
    flyToCart(sourceImg);
    btn.disabled = true;
    btn.textContent = 'Adding…';
    cartAdd(variantId, 1, null, function(err, item) {
      btn.disabled = false;
      btn.textContent = '+ Quick Add';
      if (err) { showToast('Could not add: ' + err.message); return; }
      fetchCart(function(cart) {
        updateCartUI(cart);
        openCart();
        showToast('✓ ' + (item.product_title || title) + ' added!');
      });
    });
  }

  /* ══════════════════════════════════════
     WISHLIST (localStorage)
  ══════════════════════════════════════ */
  var WISH_KEY = 'bb_wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch(e) { return []; } }
  function saveWishlist(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch(e) {} }

  function toggleWish(btn) {
    var id = btn.dataset.productId;
    if (!id) return;
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx > -1) { list.splice(idx, 1); btn.classList.remove('liked'); btn.setAttribute('aria-pressed','false'); showToast('Removed from wishlist'); }
    else { list.push(id); btn.classList.add('liked'); btn.setAttribute('aria-pressed','true'); showToast('❤️ Added to wishlist!'); }
    saveWishlist(list);
  }

  function syncWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('.p-wish[data-product-id]').forEach(function(btn) {
      var on = list.indexOf(btn.dataset.productId) > -1;
      btn.classList.toggle('liked', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ══════════════════════════════════════
     MOBILE NAV
  ══════════════════════════════════════ */
  function initMobileNav() {
    var ham  = document.getElementById('hamBtn');
    var nav  = document.getElementById('mobileNav');
    var close= document.getElementById('mobileClose');
    if (!ham || !nav) return;
    ham.addEventListener('click', function() {
      nav.classList.add('open');
      ham.setAttribute('aria-expanded','true');
      document.body.style.overflow = 'hidden';
    });
    if (close) close.addEventListener('click', function() {
      nav.classList.remove('open');
      ham.setAttribute('aria-expanded','false');
      document.body.style.overflow = '';
    });
  }

  /* ══════════════════════════════════════
     ANNOUNCEMENT BAR MARQUEE
     (JS-driven for precise speed control)
  ══════════════════════════════════════ */
  function initMarquee() {
    var el = document.querySelector('.ann-inner');
    if (!el) return;
    var pos = 0;
    var paused = false;
    var raf;
    /* Speed: pixels per frame at 60fps. ~1px/frame = comfortable reading speed */
    var PPS = 0.85;

    function tick() {
      if (!paused) {
        pos += PPS;
        var half = el.scrollWidth / 2;
        if (pos >= half) pos = 0;
        el.style.transform = 'translateX(-' + pos + 'px)';
      }
      raf = requestAnimationFrame(tick);
    }

    var bar = el.closest('.ann-bar');
    if (bar) {
      bar.addEventListener('mouseenter', function() { paused = true; });
      bar.addEventListener('mouseleave', function() { paused = false; });
    }
    raf = requestAnimationFrame(tick);
  }

  /* ══════════════════════════════════════
     SCROLL ANIMATIONS
  ══════════════════════════════════════ */
  function initScrollAnims() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.anim').forEach(function(el) { el.classList.add('vis'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); } });
    }, { threshold: 0.1 });
    document.querySelectorAll('.anim').forEach(function(el) { obs.observe(el); });
  }

  /* ══════════════════════════════════════
     SCROLL: header shadow + back to top
  ══════════════════════════════════════ */
  function initScrollBehavior() {
    var btt = document.getElementById('btt');
    window.addEventListener('scroll', function() {
      if (btt) btt.classList.toggle('on', window.scrollY > 500);
    }, { passive: true });
  }

  /* ══════════════════════════════════════
     GLOBAL EVENT DELEGATION
  ══════════════════════════════════════ */
  function initGlobalEvents() {
    document.addEventListener('click', function(e) {
      /* Cart open button */
      var cartBtn = e.target.closest('#cartBtn');
      if (cartBtn) { e.preventDefault(); openCart(); return; }

      /* Cart close */
      if (e.target.closest('#cartClose') || e.target.closest('#continueShop')) { closeCart(); return; }

      /* Overlay click */
      if (e.target.id === 'overlay') { closeCart(); return; }

      /* Quick add */
      var qa = e.target.closest('.quick-add');
      if (qa) { e.preventDefault(); quickAdd(qa); return; }

      /* Wishlist */
      var wish = e.target.closest('.p-wish');
      if (wish) { e.preventDefault(); e.stopPropagation(); toggleWish(wish); return; }
    });
  }

  /* ══════════════════════════════════════
     INIT
  ══════════════════════════════════════ */
  function init() {
    /* Expose public API FIRST so product pages can call flyToCart even if a
       later init step throws. */
    window.BrickBlast = {
      openCart: openCart,
      closeCart: closeCart,
      quickAdd: quickAdd,
      flyToCart: flyToCart,
      updateCart: function() { fetchCart(updateCartUI); },
      showToast: showToast,
      addToCart: function(variantId, qty, cb) {
        cartAdd(variantId, qty || 1, null, function(err, item) {
          if (err) { showToast('Error: ' + err.message); return; }
          fetchCart(function(cart) { updateCartUI(cart); cb && cb(item, cart); });
        });
      }
    };

    initMarquee();
    initMobileNav();
    initScrollAnims();
    initScrollBehavior();
    initGlobalEvents();
    syncWishlistButtons();

    /* Initial cart count sync */
    fetchCart(function(cart) {
      var badge = document.getElementById('cartBadge');
      if (badge && cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.classList.add('on');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
// ═══════════════════════════════════════════════════════
// SAVE FOR LATER (localStorage)
// ═══════════════════════════════════════════════════════

(function() {
  const STORAGE_KEY = 'goobingoo_saved_items';
  
  // Get saved items from localStorage
  function getSavedItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch(e) {
      return [];
    }
  }
  
  // Save items to localStorage
  function setSavedItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch(e) {
      console.error('Failed to save items:', e);
    }
  }
  
  // Render saved items in any container marked [data-saved-wrap] (drawer + cart page)
  function renderSavedItems() {
    const saved = getSavedItems();
    const wraps = document.querySelectorAll('[data-saved-wrap]');
    if (!wraps.length) return;

    const html = saved.map(item => `
      <div class="cart-item saved-item" data-variant-id="${item.variantId}">
        <a href="${item.url}" class="ci-img">
          ${item.image ? `<img src="${item.image}" alt="${item.productTitle}" width="66" height="66" loading="lazy">` : `<span>${item.productTitle.charAt(0)}</span>`}
        </a>
        <div class="ci-details">
          <div class="ci-name">${item.productTitle}</div>
          ${item.variantTitle && item.variantTitle !== 'Default Title' ? `<div class="ci-variant">${item.variantTitle}</div>` : ''}
          <div class="ci-actions">
            <button type="button" class="ci-move-to-cart" data-variant-id="${item.variantId}">Move to Cart</button>
            <button type="button" class="ci-remove-saved" data-variant-id="${item.variantId}">Remove</button>
          </div>
        </div>
        <div class="ci-price">${item.price}</div>
      </div>
    `).join('');

    wraps.forEach(wrap => {
      const list = wrap.querySelector('[data-saved-list]');
      if (!list) return;
      if (saved.length === 0) {
        wrap.style.display = 'none';
        return;
      }
      wrap.style.display = 'block';
      list.innerHTML = html;
    });
    // Click handling is delegated globally below — no per-render listeners needed.
  }

  // Global delegation for saved-item buttons (works for any container)
  document.addEventListener('click', function(e) {
    const moveBtn = e.target.closest('.ci-move-to-cart');
    if (moveBtn) {
      e.preventDefault();
      moveToCart(moveBtn.getAttribute('data-variant-id'));
      return;
    }
    const rmSaved = e.target.closest('.ci-remove-saved');
    if (rmSaved) {
      e.preventDefault();
      removeSavedItem(rmSaved.getAttribute('data-variant-id'));
    }
  });
  
  // Save item for later (remove from cart, add to localStorage)
  function saveForLater(itemKey, itemData) {
    // Add to saved items
    const saved = getSavedItems();
    const exists = saved.find(item => item.variantId === itemData.variantId);
    if (!exists) {
      saved.push(itemData);
      setSavedItems(saved);
    }
    
    // Remove from cart
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
    .then(res => res.json())
    .then(cart => {
      updateCartUI(cart);
      renderSavedItems();
      showToast('Item saved for later');
      if (/^\/cart\/?$/.test(window.location.pathname)) {
        setTimeout(function() { window.location.reload(); }, 600);
      }
    })
    .catch(err => console.error('Error saving for later:', err));
  }
  
  // Move saved item back to cart
  function moveToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      // Remove from saved items
      removeSavedItem(variantId, false); // don't show toast twice
      
      // Refresh cart
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      updateCartUI(cart);
      showToast('Item moved to cart');
      if (/^\/cart\/?$/.test(window.location.pathname)) {
        setTimeout(function() { window.location.reload(); }, 600);
      }
    })
    .catch(err => console.error('Error moving to cart:', err));
  }
  
  // Remove item from saved list
  function removeSavedItem(variantId, showToastMsg = true) {
    const saved = getSavedItems();
    const filtered = saved.filter(item => item.variantId !== variantId);
    setSavedItems(filtered);
    renderSavedItems();
    if (showToastMsg) showToast('Item removed');
  }
  
  // Event delegation for "Save for Later" buttons
  document.addEventListener('click', function(e) {
    const saveBtn = e.target.closest('.ci-save-later');
    if (saveBtn) {
      e.preventDefault();
      const itemData = {
        variantId: saveBtn.getAttribute('data-variant-id'),
        productTitle: saveBtn.getAttribute('data-product-title'),
        variantTitle: saveBtn.getAttribute('data-variant-title'),
        price: saveBtn.getAttribute('data-price'),
        image: saveBtn.getAttribute('data-image'),
        url: saveBtn.getAttribute('data-url')
      };
      const itemKey = saveBtn.getAttribute('data-key');
      saveForLater(itemKey, itemData);
      return;
    }
    // Cart-page Remove button (drawer's .ci-remove is wired separately on rebuild)
    const rmBtn = e.target.closest('.ci-remove[data-cart-page]');
    if (rmBtn) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rmBtn.getAttribute('data-key'), quantity: 0 })
      })
      .then(res => res.json())
      .then(cart => {
        updateCartUI(cart);
        showToast('Item removed');
        if (/^\/cart\/?$/.test(window.location.pathname)) {
          setTimeout(function() { window.location.reload(); }, 600);
        }
      })
      .catch(err => console.error('Error removing item:', err));
    }
  });
  
  // Render saved items when cart drawer opens
  const cartDrawer = document.getElementById('cartDrawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class' && cartDrawer.classList.contains('open')) {
          renderSavedItems();
        }
      });
    });
    observer.observe(cartDrawer, { attributes: true });
  }
  
  // Initial render
  renderSavedItems();
  
  // Helper: show toast notification
  function showToast(msg) {
    const toast = document.getElementById('toast');
    const toastTxt = document.getElementById('toastTxt');
    if (toast && toastTxt) {
      toastTxt.textContent = msg;
      toast.classList.add('show');
      setTimeout(() => toast.classList.remove('show'), 2500);
    }
  }
  
  // Helper: update cart UI after changes (reuses existing updateCartUI if present, or defines minimal version)
  function updateCartUI(cart) {
    if (typeof window.updateCartUI === 'function') {
      window.updateCartUI(cart);
    } else {
      // Minimal fallback
      fetch('/?section_id=cart-drawer')
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBody = doc.querySelector('#cartBody');
          const oldBody = document.getElementById('cartBody');
          if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
          
          const newCount = doc.querySelector('#drawerCount');
          const oldCount = document.getElementById('drawerCount');
          if (newCount && oldCount) oldCount.textContent = newCount.textContent;
          
          renderSavedItems();
        });
    }
  }
})();

/* ── Countdown timer ────────────────────────────────────────────────
   Ticks every second. Resolves an effective end time per element ONCE
   on init (so auto-roll doesn't re-extend on every tick). If the
   canonical end has passed and auto-roll is enabled, rolls forward by
   the configured window. Otherwise hides the element. */
(function() {
  var nodes = document.querySelectorAll('.countdown[data-countdown-end]');
  if (!nodes.length) return;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var now = Date.now();
  var entries = [];
  nodes.forEach(function(el) {
    var canonical = new Date(el.getAttribute('data-countdown-end')).getTime();
    var rollDays = parseInt(el.getAttribute('data-countdown-roll-days') || '0', 10);
    if (isNaN(canonical)) { el.style.display = 'none'; return; }
    var end = canonical;
    if (end <= now) {
      if (rollDays > 0) {
        var windowMs = rollDays * 86400000;
        var rolls = Math.ceil((now - canonical) / windowMs);
        end = canonical + rolls * windowMs;
        if (end <= now) end = canonical + (rolls + 1) * windowMs;
      } else {
        el.style.display = 'none';
        return;
      }
    }
    entries.push({ el: el, end: end });
  });
  if (!entries.length) return;

  function tick() {
    var t = Date.now();
    entries.forEach(function(entry) {
      var diff = entry.end - t;
      if (diff <= 0) { entry.el.style.display = 'none'; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      entry.el.querySelector('.cd-days').textContent = pad(d);
      entry.el.querySelector('.cd-hours').textContent = pad(h);
      entry.el.querySelector('.cd-mins').textContent = pad(m);
      entry.el.querySelector('.cd-secs').textContent = pad(s);
    });
  }
  tick();
  setInterval(tick, 1000);
})();

/* ── Exit-intent popup ──────────────────────────────────────────
   Storage keys:
     localStorage.epDone       — permanent flag once they sign up
     sessionStorage.epShown    — already shown this tab/session
     sessionStorage.epDismissed— dismissed (X / overlay) this session
   Triggers:
     desktop: mouseout from top of viewport
     mobile : 25s on page (fallback, since touch has no mouseleave)
   Skips:
     /cart, /checkout, after submission, after dismissal,
     and if a real dialog/cart-drawer is currently open.            */
(function() {
  var popup = document.getElementById('exitPopup');
  if (!popup) return;

  var formState = popup.querySelector('[data-popup-state="form"]');
  var successState = popup.querySelector('[data-popup-state="success"]');

  function open(stateName) {
    if (stateName === 'success') {
      formState.hidden = true;
      successState.hidden = false;
    } else {
      formState.hidden = false;
      successState.hidden = true;
    }
    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    popup.classList.remove('open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  popup.querySelectorAll('[data-popup-close]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      close();
      sessionStorage.setItem('epDismissed', '1');
    });
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('open')) close();
  });

  // After Shopify redirects back from a successful submit, re-open in success state.
  // Only treat it as "ours" if we set the marker right before submitting.
  var params = new URLSearchParams(location.search);
  if (params.get('customer_posted') === 'true' && sessionStorage.getItem('epSubmitting')) {
    sessionStorage.removeItem('epSubmitting');
    localStorage.setItem('epDone', '1');
    open('success');
    // Clean the URL so a refresh doesn't keep re-opening.
    if (history.replaceState) {
      params.delete('customer_posted');
      var clean = location.pathname + (params.toString() ? '?' + params.toString() : '') + location.hash;
      history.replaceState({}, '', clean);
    }
    return;
  }

  // Mark the form as ours when it's submitted, so the redirect-back logic above can identify it.
  var form = document.getElementById('exitPopupForm');
  if (form) {
    form.addEventListener('submit', function() {
      sessionStorage.setItem('epSubmitting', '1');
    });
  }

  // Skip conditions
  if (localStorage.getItem('epDone')) return;
  if (sessionStorage.getItem('epDismissed') || sessionStorage.getItem('epShown')) return;
  var path = location.pathname;
  if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;
  // Don't compete with the cart drawer
  function drawerOpen() {
    var d = document.getElementById('cartDrawer');
    return d && d.classList.contains('on');
  }

  function trigger() {
    if (sessionStorage.getItem('epShown') || drawerOpen()) return;
    sessionStorage.setItem('epShown', '1');
    open('form');
  }

  // Desktop: mouseout from top of viewport
  document.addEventListener('mouseout', function(e) {
    if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) trigger();
  });

  // Mobile fallback: 25s after page load
  setTimeout(trigger, 25000);
})();